import { Navigate, useLocation, useParams } from "react-router-dom";
import { ROUTES } from "@shared/routes";

/**
 * Class links already handed to students are `/classe/{id}#{code}`: the move to English paths must
 * not turn them into dead ends, and the access code lives in the hash, so the hash travels along.
 */
export const LegacyClassRedirect = () => {
  const { id = "" } = useParams();
  const { hash, search } = useLocation();

  return <Navigate to={{ pathname: ROUTES.classOf(id), hash, search }} replace />;
};
